// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec4ee0cb","453":"9a1dfd65","732":"a07304f2","879":"fb8a6fc0"}[chunkId] + ".chunk.js";
};